import { render, staticRenderFns } from "./disclosureIcp.vue?vue&type=template&id=31345e4c"
import script from "./disclosureIcp.vue?vue&type=script&lang=js"
export * from "./disclosureIcp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31345e4c')) {
      api.createRecord('31345e4c', component.options)
    } else {
      api.reload('31345e4c', component.options)
    }
    module.hot.accept("./disclosureIcp.vue?vue&type=template&id=31345e4c", function () {
      api.rerender('31345e4c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/template/frontPageManage/configureManage/configure/components/disclosureIcp.vue"
export default component.exports